import { render, staticRenderFns } from "./announcement-banner-content.vue?vue&type=template&id=17f5e20a&"
import script from "./announcement-banner-content.vue?vue&type=script&lang=js&"
export * from "./announcement-banner-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports